import { DownloadButtonComponent } from './DownloadButton';
export default DownloadButtonComponent;
